/* eslint-disable */

const serialize = function(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

try {
  var websocket_proxy = require("@/services/websocket.js").default;
} catch (err) {
  try {
    var websocket_proxy = require("@/framework/services/websocket.js").default;
  } catch (err) {}
}


export default {
  load(path = "", mode = "get", query = null, post = null, ondata = null) {
    let wsp = websocket_proxy(path, mode, query, post, ondata);
    if (wsp) return wsp;

    const Api = global.Api;

    let path2 = path;
    if (query) path2 += "?" + serialize(query);

    if (mode == "get") {
      if (ondata) return Api().get(path2, { onUploadProgress: ondata });

      return Api().get(path2);
    }
    if (mode == "post") {
      if (ondata) return Api().post(path2, post, { onUploadProgress: ondata });

      return Api().post(path2, post);
    }
  },
  jsons() {
    const Api = global.Api;
    return Api().get("admin/metadmin/modulos/jsons");
  }
};
